'use client'

import { useLayoutEffect, useRef, ReactNode } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const HomePresentationWrapper = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Giriş animasyonu
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ref.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      })

      tl.from('.hp-text', {
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out'
      })
        .from(
          '.hp-img-left',
          {
            x: -100,
            opacity: 0,
            duration: 1,
            ease: 'power3.out'
          },
          '-=0.4'
        )
        .from(
          '.hp-img-right',
          {
            x: 100,
            opacity: 0,
            duration: 1,
            ease: 'power3.out'
          },
          '<'
        )
        .from(
          '.hp-callout',
          {
            y: 40,
            opacity: 0,
            scale: 0.85,
            duration: 0.7,
            ease: 'back.out(1.7)'
          },
          '-=0.3'
        )

      // Çıkış animasyonu — scroll edildikçe yukarı kayar
      gsap.to(ref.current, {
        y: -60,
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: ref.current,
          start: 'bottom 40%',
          end: 'bottom top',
          scrub: true
        }
      })
    }, ref)

    return () => ctx.revert()
  }, [])

  return (
    <div ref={ref} className="container mx-auto flex flex-col gap-8">
      {children}
    </div>
  )
}

export default HomePresentationWrapper
